document.addEventListener("DOMContentLoaded", () => {
  const FALLBACK_MAIN_TO_FREEBIE_MAP = {
    //  41898213736525: 43044521312333,
    //  41898213703757: 43044521279565,
    41898213670989: 43044521246797,
    //  43144296464461: 43044521312333,
    //  43144296497229: 43044521279565,
    41898218422349: 43044521246797,
    43218375442509: 43044521246797,
    43218375475277: 43044521246797,
    43218375508045: 43044521246797,
    43233005797453: 43044521246797,
    43233005830221: 43044521246797,
    43233005764685: 43044521246797,
    //  43091428966477: 43044521312333,
    //  43091428999245: 43044521279565,
    42068472397901: 43044521246797,
    //  43088524673101: 43044521312333,
    //  43088524705869: 43044521279565,
    41905203281997: 43044521246797,
    //  42930349604941: 43044521312333,
    //  42930349637709: 43044521279565,
    42930339446861: 43044521246797,
    42878153850957: 43044521246797,
    42989488078925: 43044521246797,
    42989493813325: 43044521246797,
    43116940361805: 43044521246797,
    42351446130765: 43044521246797,
    43349626585165: 43044521246797
  };

  const strawsFreebieConfig = window.NM_STRAWS_FREEBIE_CONFIG || {};
  const MAIN_TO_FREEBIE_MAP = normalizeVariantMap(
    strawsFreebieConfig.mainToFreebieMap || FALLBACK_MAIN_TO_FREEBIE_MAP,
  );
  const SUBSCRIPTION_SUBSTITUTE_MAP = normalizeVariantMap(
    strawsFreebieConfig.subscriptionSubstitutes || {},
  );
  const MAIN_VARIANT_IDS = Object.keys(MAIN_TO_FREEBIE_MAP).map(Number);
  const FREEBIE_IDS = [
    ...new Set([
      ...Object.values(MAIN_TO_FREEBIE_MAP),
      ...Object.values(SUBSCRIPTION_SUBSTITUTE_MAP),
    ]),
  ];

  let skeletonCheckInterval;
  let lastFreebieCount = 0;
  let lastHasMain = false;
  let lastMainAddedAt = 0;
  let isLoadingFreebies = false;
  let lastAddedMainId = null;
  const STATUS_BANNER_SOURCE = "freebie-straws";

  function getStatusBannerState() {
    if (!window.__freebieStatusBannerState) {
      window.__freebieStatusBannerState = {
        activeSources: new Set(),
        hideTimer: null,
        isVisible: false,
        sourceShownAt: {},
      };
    }
    if (!window.__freebieStatusBannerState.sourceShownAt) {
      window.__freebieStatusBannerState.sourceShownAt = {};
    }
    return window.__freebieStatusBannerState;
  }

  function getSkeletonContainer() {
    return document.querySelector("#freebie-skeleton-container");
  }

  function getStatusBanner() {
    let banner = document.querySelector("#freebie-status-banner");
    if (!banner) {
      banner = document.createElement("div");
      banner.id = "freebie-status-banner";
      banner.innerHTML = "🎁 Adding your free gifts…";
      document.querySelector(".drawer__cart-items-wrapper")?.prepend(banner);
    }
    const state = getStatusBannerState();
    banner.classList.toggle("visible", state.isVisible);
    return banner;
  }

  function setStatusBannerVisible(banner, isVisible) {
    const state = getStatusBannerState();
    const hideCurrentBanners = () => {
      state.isVisible = false;
      document
        .querySelectorAll("#freebie-status-banner")
        .forEach((el) => el.classList.remove("visible"));
    };
    const scheduleHide = (delay) => {
      state.hideTimer = setTimeout(() => {
        const now = Date.now();
        const hasFreshSource = Array.from(state.activeSources).some(
          (source) => now - (state.sourceShownAt[source] || 0) < 1800,
        );
        if (hasFreshSource) {
          scheduleHide(300);
        } else {
          state.activeSources.clear();
          state.sourceShownAt = {};
          hideCurrentBanners();
          state.hideTimer = null;
        }
      }, delay);
    };

    if (isVisible) {
      clearTimeout(state.hideTimer);
      state.hideTimer = null;
      state.activeSources.add(STATUS_BANNER_SOURCE);
      state.sourceShownAt[STATUS_BANNER_SOURCE] = Date.now();
      state.isVisible = true;
      banner.classList.add("visible");
      return;
    }

    state.activeSources.delete(STATUS_BANNER_SOURCE);
    delete state.sourceShownAt[STATUS_BANNER_SOURCE];
    clearTimeout(state.hideTimer);
    state.hideTimer = null;
    if (!state.isVisible) {
      banner.classList.remove("visible");
      return;
    }

    scheduleHide(300);
  }

  function restoreStatusBannerVisibility() {
    const state = getStatusBannerState();
    if (!state.isVisible) return;
    getStatusBanner().classList.add("visible");
  }

  function showSkeleton(container, banner) {
    container.classList.add("active");
    container
      .querySelectorAll(".freebie-skeleton")
      .forEach((el) => el.classList.add("active"));
    setStatusBannerVisible(banner, true);
  }

  function hideSkeleton(container, banner) {
    container.classList.remove("active");
    container
      .querySelectorAll(".freebie-skeleton")
      .forEach((el) => el.classList.remove("active"));
    setStatusBannerVisible(banner, false);
  }

  function isAutoShipTabActive() {
    const autoShip = document.querySelector("#auto-ship");
    return autoShip && autoShip.classList.contains("active");
  }

  function toVariantId(value) {
    const id = Number(value);
    return Number.isFinite(id) && id > 0 ? id : null;
  }

  function normalizeVariantMap(map) {
    return Object.entries(map || {}).reduce(
      (normalized, [rawKey, rawValue]) => {
        const key = toVariantId(rawKey);
        const value = toVariantId(rawValue);
        if (key && value) normalized[key] = value;
        return normalized;
      },
      {},
    );
  }

  function getExpectedFreebieId(cartItem) {
    const baseFreebieId = MAIN_TO_FREEBIE_MAP[cartItem.variant_id];
    if (!baseFreebieId) return null;
    if (
      cartItem.selling_plan_allocation &&
      SUBSCRIPTION_SUBSTITUTE_MAP[baseFreebieId]
    ) {
      return SUBSCRIPTION_SUBSTITUTE_MAP[baseFreebieId];
    }
    return baseFreebieId;
  }

  function buildExpectedFreebieQuantities(cart) {
    return cart.items.reduce((expected, item) => {
      const expectedFreebieId = getExpectedFreebieId(item);
      if (expectedFreebieId) {
        expected[expectedFreebieId] =
          (expected[expectedFreebieId] || 0) + item.quantity;
      }
      return expected;
    }, {});
  }

  function buildFreebiesInCart(cart) {
    return cart.items.reduce((freebies, item) => {
      if (FREEBIE_IDS.includes(item.variant_id)) {
        freebies[item.variant_id] =
          (freebies[item.variant_id] || 0) + item.quantity;
      }
      return freebies;
    }, {});
  }

  function getMissingFreebieMap(cart) {
    const missing = {};
    const expectedFreebieQuantities = buildExpectedFreebieQuantities(cart);
    const freebiesInCart = buildFreebiesInCart(cart);
    Object.entries(expectedFreebieQuantities).forEach(
      ([freebieId, expectedQty]) => {
        const currentQty = freebiesInCart[freebieId] || 0;
        if (currentQty < expectedQty) {
          missing[freebieId] = expectedQty - currentQty;
        }
      },
    );
    return missing;
  }

  function hasAnyMissingFreebie(cart) {
    return Object.keys(getMissingFreebieMap(cart)).length > 0;
  }

  async function checkCartForFreebies() {
    const skeletonContainer = getSkeletonContainer();
    if (!skeletonContainer) return;

    const banner = getStatusBanner();

    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      const hasMain = cart.items.some((i) =>
        MAIN_VARIANT_IDS.includes(i.variant_id),
      );

      const freebiesInCart = cart.items.filter((i) =>
        FREEBIE_IDS.includes(i.variant_id),
      );

      const missingFreebieMap = getMissingFreebieMap(cart);
      const now = Date.now();

      const allFreebiesLoaded = Object.keys(missingFreebieMap).length === 0;

      if (hasMain && !lastHasMain) {
        const missingOnAdd = getMissingFreebieMap(cart);
        if (Object.keys(missingOnAdd).length > 0) {
          lastMainAddedAt = now;
          isLoadingFreebies = true;
          lastAddedMainId = Object.keys(missingOnAdd)[0];
          showSkeleton(skeletonContainer, banner);
        }
      }

      if (!hasMain) {
        hideSkeleton(skeletonContainer, banner);
        clearInterval(skeletonCheckInterval);
        lastFreebieCount = 0;
        lastHasMain = false;
        isLoadingFreebies = false;
        return;
      }

      if (isLoadingFreebies && !allFreebiesLoaded) {
        showSkeleton(skeletonContainer, banner);
      }

      if (allFreebiesLoaded) {
        hideSkeleton(skeletonContainer, banner);
        clearInterval(skeletonCheckInterval);
        lastFreebieCount = freebiesInCart.length;
        lastHasMain = hasMain;
        isLoadingFreebies = false;
        return;
      }

      lastFreebieCount = freebiesInCart.length;
      lastHasMain = hasMain;
    } catch (err) {
      console.error("⚠️ Freebie skeleton check failed:", err);
    }
  }

  function startSkeletonWatcher() {
    clearInterval(skeletonCheckInterval);
    restoreStatusBannerVisibility();
    setTimeout(checkCartForFreebies, 100);
    skeletonCheckInterval = setInterval(checkCartForFreebies, 500);
  }

  document.addEventListener("cart:updated", () => {
    startSkeletonWatcher();
  });
  document.addEventListener("cart:refresh", () => {
    startSkeletonWatcher();
  });
  document.addEventListener("shopify:section:load", () => {
    startSkeletonWatcher();
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.id === "CartDrawer" || node.querySelector?.("#CartDrawer")) {
          startSkeletonWatcher();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.querySelector("#CartDrawer")) {
    startSkeletonWatcher();
  }
});
